<template>
  <div class="ArtistFollowButton">
    <div v-if="artist.user_signed_in">
      <button
        :disabled="isLoading"
        v-show="!following"
        @click="follow"
        :title="tooltipMessage"
        v-tippy
        class="ArtistFollowButton-Follow btn btn-outline-blue text-uppercase h-20 items-center flex justify-center"
      >
        <i class="text-lg fal fa-plus-circle mr-2 md:mt-1" />
        Follow
      </button>
      <button
        :disabled="isLoading"
        v-show="following"
        @click="unfollow"
        class="ArtistFollowButton-Follow btn btn-outline-blue text-uppercase h-20"
      >
        Following
      </button>
    </div>
    <div v-else>
      <a
        href="#"
        class="ArtistFollowButton-Follow btn btn-outline-blue text-uppercase items-center flex justify-center"
        data-toggle="modal"
        data-target="#session-modal"
        :title="tooltipMessage"
        v-tippy
      >
        <i class="text-lg fal fa-plus-circle mr-2 md:mt-1" />
        <span class="ml-2"> Follow </span>
      </a>
    </div>
  </div>
</template>

<script setup>
import Http from "@/lib/Http"
import { inject, ref } from "vue"

const artist = inject("artist")
const following = ref(artist.following)
const isLoading = ref(false)

const tooltipMessage = "Get email notifications for new works from this artist"

const follow = async () => {
  isLoading.value = true
  await Http.post("/api/follows", {
    resource: "Artist",
    id: artist.id,
  }).finally(() => (isLoading.value = false))
  following.value = true
}

const unfollow = async () => {
  isLoading.value = true
  await Http.delete(`/api/follows/${artist.id}`, {
    params: { resource: "Artist" },
  }).finally(() => (isLoading.value = false))
  following.value = false
}
</script>

<script>
export default {
  name: "ArtistFollowButton",
}
</script>

<style scoped>
.ArtistFollowButton {
  font-family: "Lato";
}

.ArtistFollowButton-Follow {
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 2px;
  line-height: 17px;
  padding: 17px 0;
}
</style>
